import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import DMBoverview from './DMBoverview'
const DMBbanner = () => {
  const [bannerTitle, setBannerTitle] = useState('Digital Marketing Camp');

  useEffect(() => {
    // This could be a placeholder for setting banner details, for example, fetching data
    setBannerTitle('Welcome to the Digital Marketing Camp');
  }, []);

  return (
    <>
      <Helmet>
        <title>{bannerTitle}</title>
        <meta name="description" content="Join our Digital Marketing Camp and learn new strategies for marketing!" />
      </Helmet>
      <div className="rbt-breadcrumb-default rbt-breadcrumb-style-3">
        <div className="breadcrumb-inner">
            <img src="assets/images/bg/bg-image-10.jpg" alt="Education Images"/>
        </div>
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <div className="content text-start">
                        <ul className="page-list">
                            <li className="rbt-breadcrumb-item"><a href="/">Home</a></li>
                            <li>
                                <div className="icon-right"><i className="feather-chevron-right"></i></div>
                            </li>
                            <li className="rbt-breadcrumb-item active"> <span className='textred'>Digital Marketing Bootcamp</span></li>
                        </ul>
                        <h2 className="title"> <span className='textred'>Digital Marketing Bootcamp: Strategy to Execution in 3 Hours</span></h2>
                        <p className="description">  A power-packed 2-day workshop designed to equip you with practical digital marketing skills — from foundational strategy to real-world execution.
</p>

                        <div className="d-flex align-items-center mb--20 flex-wrap rbt-course-details-feature">

                            <div className="feature-sin best-seller-badge">
                                <span className="rbt-badge-2">
                                    <span className="image"><img src="assets/images/icons/card-icon-1.png"
                                            alt="Best Seller Icon"/></span> online learning platform
                                </span>
                            </div>

                            <div className="feature-sin rating">
                                <a href="#">4.6</a>
                                <a href="#"><i className="fa fa-star"></i></a>
                                <a href="#"><i className="fa fa-star"></i></a>
                                <a href="#"><i className="fa fa-star"></i></a>
                                <a href="#"><i className="fa fa-star"></i></a>
                                <a href="#"><i className="fa fa-star-half-o"></i></a>
                            </div>

                            <div className="feature-sin total-rating">
                                <a className="rbt-badge-4" href="#">15,475 rating</a>
                            </div>

                            <div className="feature-sin total-student">
                                <span>16,029 students</span>
                            </div>

                        </div>

                        <div className="rbt-author-meta mb--20">
                            <div className="rbt-avater">
                                <a href="#">
                                    <img src="assets/images/team/team-07.jpeg" alt="Tejasvita Goel"/>
                                </a>
                            </div>
                            <div className="rbt-author-info">
                                By <a href="#">Pradeep Kumar Mishra</a> In <a href="#">Digital Marketing Bootcamp</a>
                            </div>
                        </div>

                        <ul className="rbt-meta">
                            <li><i className="feather-calendar"></i>Last updated 05/2025</li>
                            <li><i className="feather-globe"></i>English/Hindi</li>
                            <li><i className="feather-award"></i>Certified Course</li>
                        </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <DMBoverview/>
    </>
  );
}

export default DMBbanner;
